export default function MissionSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-deep-black to-forest-green/20">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="bg-forest-green rounded-3xl p-12 lg:p-20 text-center relative overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-copper/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-copper/5 rounded-full blur-3xl"></div>

          <div className="relative">
            {/* Quote Marks */}
            <div className="text-copper text-8xl font-serif leading-none mb-6 opacity-30">"</div>

            {/* Quote Text */}
            <blockquote className="font-serif text-3xl lg:text-4xl text-white leading-relaxed mb-8">
              We don't just sell products—we cultivate experiences, build community, and set the standard for excellence in everything we do.
            </blockquote>

            {/* Attribution */}
            <p className="text-copper font-medium text-lg">
              The High Standards Team
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
